module.exports = __webpack_public_path__ + "media/images/admin/icons/mic-off-bdfa9d85026a8db0737dc299f928ff3c.svg";